import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Profile from "../page/Profile";

const routes: AppRouteType[] = [
  {
    path: slugs.profile,
    component: Profile,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
